import { render } from "./AppPopoverItem.vue?vue&type=template&id=0370d246&scoped=true"
const script = {}

import "./AppPopoverItem.vue?vue&type=style&index=0&id=0370d246&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0370d246"]])

export default __exports__